import React from 'react';
import { useSelector } from 'react-redux';
import { Stack, Typography } from '@mui/material';
import { ACLQueryModeTypes } from 'js/constants/visibilityFilters';
import { setListingACLQueryMode } from 'js/actions';
import { Switch } from '../Switch';
import useAppDispatch from 'js/hooks/useAppDispatch';

interface AclSelectionProps {
  onChange: (mode: string) => void;
}

export const AclSelection = ({ onChange }: AclSelectionProps) => {
  const dispatch = useAppDispatch();
  const { aclQueryMode } = useSelector((state: any) => state.app.listing);
  const isCollabView = aclQueryMode === ACLQueryModeTypes.MODE_COLLABORATOR.key;

  const onModeChange = () => {
    const newMode = isCollabView
      ? ACLQueryModeTypes.MODE_OWNER.key
      : ACLQueryModeTypes.MODE_COLLABORATOR.key;

    dispatch(setListingACLQueryMode(newMode));
    onChange(newMode);
  };

  return (
    <Stack direction="row" alignItems="center">
      <Typography variant="body2">Accessible to me</Typography>
      <Switch checked={isCollabView} onChange={onModeChange} />
    </Stack>
  );
};
